import * as COLORS from '@/app/theme/colors/cleartrip'
import '@/src/types/theme'; // Import theme type extensions
import { ThemeOptions } from '@mui/material/styles'

const cleartripTheme: ThemeOptions = {
    palette: {
        primary: {
            main: COLORS.BRAND_PRIMARY,
            dark: COLORS.BRAND_PRIMARY_DARK,
            light: COLORS.BRAND_PRIMARY_LIGHT,
            '100': COLORS.BRAND_PRIMARY_100
        },
        secondary: {
            main: COLORS.BRAND_SECONDARY,
            dark: COLORS.BRAND_SECONDARY_DARK,
            light: COLORS.BRAND_SECONDARY_LIGHT
        },
        neutral: {
            white: COLORS.WHITE,
            100: COLORS.NEUTRAL_100,
            black: COLORS.BLACK
        },
        borders: {
            default: COLORS.BORDER_MAIN,
            heavy: COLORS.BORDER_SECONDARY
        },
        textColors: {
            primary: COLORS.TEXT_PRIMARY,
            secondary: COLORS.TEXT_SECONDARY,
            disabled: COLORS.TEXT_DISABLED,
            subheading: COLORS.TEXT_SUBHEADING,
            subtitle: COLORS.TEXT_SUBTITLE
        },
        link: {
            main: COLORS.LINK_MAIN
        },
        error: {
            main: COLORS.ERROR_MAIN,
            light: COLORS.ERROR_LIGHT
        },
        success: {
            main: COLORS.SUCCESS_MAIN,
            light: COLORS.SUCCESS_LIGHT
        },
        warning: {
            main: COLORS.WARNING_MAIN
        },
        customThemeButton: {
            primaryBg: '#f66826',
            primaryText: COLORS.WHITE,
            primaryHoverBg: '#d4581d',
            secondaryBg: COLORS.BRAND_SECONDARY,
            secondaryText: COLORS.WHITE,
            secondaryHoverBg: COLORS.BRAND_SECONDARY_DARK,
            disabledBg: COLORS.NEUTRAL_100,
            disabledText: COLORS.TEXT_DISABLED
        },
        seatColors: {
            color0: COLORS.SEAT_LAYOUT_COLORS_0,
            color1: COLORS.SEAT_LAYOUT_COLORS_1,
            color2: COLORS.SEAT_LAYOUT_COLORS_2,
            color3: COLORS.SEAT_LAYOUT_COLORS_3,
            color4: COLORS.SEAT_LAYOUT_COLORS_4,
            color5: COLORS.SEAT_LAYOUT_COLORS_5,
            unavailable: COLORS.UNAVAILABLE_SEAT_COLOR
        }
    },
    typography: {
        fontFamily:
            'Claudian, var(--font-noto-kufi-arabic, var(--font-open-sans)), "Noto Kufi Arabic", "Open Sans", sans-serif',
        h1: {
            fontWeight: 300
        },
        h2: {
            fontWeight: 300
        },
        h3: {
            fontWeight: 400
        },
        h4: {
            fontWeight: 400
        },
        h5: {
            fontWeight: 500
        },
        h6: {
            fontWeight: 500
        },
        button: {
            textTransform: 'none'
        }
    },
    shape: {
        borderRadius: 8
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: '0.5rem'
                }
            },
            variants: [
                {
                    props: { variant: 'customVariantPrimary' },
                    style: ({ theme }) => ({
                        backgroundColor: theme.palette.customThemeButton.primaryBg,
                        color: theme.palette.customThemeButton.primaryText,
                        '&:hover': {
                            backgroundColor: theme.palette.customThemeButton.primaryHoverBg
                        },
                        '&.Mui-disabled': {
                            backgroundColor: theme.palette.customThemeButton.disabledBg,
                            color: theme.palette.customThemeButton.disabledText
                        }
                    })
                },
                {
                    props: { variant: 'customVariantSecondary' },
                    style: ({ theme }) => ({
                        backgroundColor: theme.palette.customThemeButton.secondaryBg,
                        color: theme.palette.customThemeButton.secondaryText,
                        '&:hover': {
                            backgroundColor: theme.palette.customThemeButton.secondaryHoverBg
                        },
                        '&.Mui-disabled': {
                            backgroundColor: theme.palette.customThemeButton.disabledBg,
                            color: theme.palette.customThemeButton.disabledText
                        }
                    })
                }
            ]
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none'
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontWeight: 500
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none'
                }
            },
            defaultProps: {
                variant: 'outlined'
            }
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 300,
            md: 640,
            lg: 1024,
            xl: 1280
        }
    }
}

export default cleartripTheme
